import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const BoldUserBoardIcon: FC<Props> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.78406 6.24343C5.66985 6.25382 5.53574 6.27392 5.40344 6.32082C6.07531 4.89929 7.35974 4.10692 9.09123 4.10692H16.1989C18.7036 4.10692 20.4367 5.91799 20.353 8.43001L20.3527 8.4377V8.44539V14.5377C20.3527 15.8627 19.9054 16.9671 19.1659 17.7373C18.4279 18.5061 17.374 18.9684 16.1066 18.9684H12.4687L12.5066 18.8928V18.8416L12.5067 18.8413L12.5068 18.8408L12.5077 18.8377C12.5711 18.62 12.7673 17.9455 12.6202 17.1412C12.47 16.3193 11.9711 15.4131 10.7551 14.7191C11.383 13.8798 11.6758 12.6678 11.6758 11.6761C11.6758 8.65203 9.25382 6.23 6.22969 6.23L6.21991 6.23C6.08825 6.22999 5.93204 6.22998 5.78406 6.24343ZM12.4143 18.9684C12.4143 18.9684 12.4144 18.9684 12.4144 18.9684H12.4143ZM15.0911 17.2142H17.2142C17.7997 17.2142 18.4142 16.7677 18.4142 16.0142C18.4142 15.2608 17.7997 14.8142 17.2142 14.8142H15.0911C14.7678 14.8142 14.455 14.913 14.2224 15.1456C13.9899 15.3781 13.8911 15.6909 13.8911 16.0142C13.8911 16.7677 14.5056 17.2142 15.0911 17.2142Z"
        fill={props.fill || "currentColor" || "#3064C0"}
        stroke={props.fill || "currentColor" || "#3064C0"}
        strokeWidth="0.923077"
      />
      <path
        d="M8.72203 11.7681C8.72203 13.1748 7.63636 14.2605 6.22972 14.2605C4.82309 14.2605 3.73742 13.1748 3.73742 11.7681C3.73742 10.3615 4.82308 9.27587 6.22972 9.27587C7.63637 9.27587 8.72203 10.3615 8.72203 11.7681Z"
        fill={props.fill || "currentColor" || "#3064C0"}
        stroke={props.fill || "currentColor" || "#3064C0"}
        strokeWidth="0.923077"
      />
      <path
        d="M2.0758 18.23C2.0758 17.8423 2.22416 17.5667 2.47102 17.3483C2.73315 17.1164 3.11757 16.9418 3.57966 16.8182C4.50498 16.5707 5.57706 16.5685 6.13733 16.5685C6.69761 16.5685 7.7697 16.5707 8.69502 16.8182C9.15711 16.9418 9.54154 17.1164 9.80366 17.3483C10.0505 17.5667 10.1989 17.8423 10.1989 18.23C10.1989 18.6178 10.0505 18.8933 9.80366 19.1117C9.54154 19.3436 9.15711 19.5183 8.69502 19.6418C7.7697 19.8893 6.69761 19.8915 6.13733 19.8915C5.57706 19.8915 4.50498 19.8893 3.57966 19.6418C3.11757 19.5183 2.73315 19.3436 2.47102 19.1117C2.22416 18.8933 2.0758 18.6178 2.0758 18.23Z"
        fill={props.fill || "currentColor" || "#3064C0"}
        stroke={props.fill || "currentColor" || "#3064C0"}
        strokeWidth="0.923077"
      />
    </svg>
  );
};

export default BoldUserBoardIcon;
